module.exports = __webpack_public_path__ + "static/media/DWZ_04.757f3199.jpg";